<template>
  <layout-full>
    <router-view  :language="language" @selectLanguageEv="selectLang" />
  </layout-full>
</template>

<script>
import LayoutFull from '@core/layouts/layout-full/LayoutFull.vue'

export default {
  components: {
    LayoutFull,
  },
  data() {
        return {
          language: 'en',
          
        }
      },
      methods: {
        selectLang(lang) {
          this.language = lang
        }
      }
}
</script>
